
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    statistics: Object,
  },
});
